export default {"src":"/_next/static/media/tracesmobile.e8e1bdea.svg","height":911,"width":1454,"blurWidth":0,"blurHeight":0};